import React from "react";
import JumboContainer from "./common/JumboContainer";
import { faFacebookF, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { Card } from "react-bootstrap";

import "../styles/Team.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  TEAM_MEMBER_1_DESCRIPTION,
  TEAM_MEMBER_1_NAME,
  TEAM_MEMBER_1_ROLE,
  TEAM_MEMBER_2_NAME,
  TEAM_MEMBER_2_ROLE,
  TEAM_MEMBER_2_DESCRIPTION,
} from "../data/i18n/team";

import Rajendra from "../assets/images/team/Rajendra.jpeg";
import Chandra from "../assets/images/team/Chandra.jpeg";

import { FOUNDERS } from "../data/navbar/menu";

const members = [
  {
    name: TEAM_MEMBER_1_NAME,
    role: TEAM_MEMBER_1_ROLE,
    image: Rajendra,
    description: TEAM_MEMBER_1_DESCRIPTION,
    // motivation: "BCD",
    socials: [
      {
        thumbnail: faFacebookF,
        link: "https://facebook.com/freshokartz",
      },
      {
        thumbnail: faLinkedinIn,
        link: "https://www.facebook.com/rajendra.lora",
      },
    ],
  },
  {
    name: TEAM_MEMBER_2_NAME,
    role: TEAM_MEMBER_2_ROLE,
    image: Chandra,
    description: TEAM_MEMBER_2_DESCRIPTION,
    // motivation: "BCD",
    socials: [
      {
        thumbnail: faFacebookF,
        link: "https://www.facebook.com/csohu",
      },
      {
        thumbnail: faLinkedinIn,
        link: "https://www.linkedin.com/in/chandrakanta-sahu-6795095a/",
      },
    ],
  },
];

const Team = () => {
  const { t } = useTranslation();

  return (
    <JumboContainer id="team" white title={t(FOUNDERS)}>
      <div class="team-list">
        {members.map((member) => (
          <Card
            style={{
              width: "20rem",
              padding: "20px",
              borderWidth: 0,
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            <Card.Img
              style={{
                width: "100%",
              }}
              class="team-memeber_image"
              variant="top"
              src={member.image}
            />
            <Card.Body>
              <Card.Title class="team-member_name">{t(member.name)}</Card.Title>
              <Card.Text>
                <p class="team-member_role">{t(member.role)}</p>
                <p class="team-member_description">{t(member.description)}</p>
                {/* <p class="team-member_motivation">{member.motivation}</p> */}

                <div class="team-member_social">
                  {member.socials.map((social) => (
                    <a
                      class="social-link"
                      rel="noreferrer"
                      target="_blank"
                      href={social.link}
                    >
                      <FontAwesomeIcon
                        icon={social.thumbnail}
                        color="white"
                        size="sm"
                      />
                    </a>
                  ))}
                </div>
              </Card.Text>
            </Card.Body>
          </Card>
        ))}
      </div>
    </JumboContainer>
  );
};

export default Team;
